import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { addMessageToConversation } from '@/v2/hooks/messages/useMessages'
import RealTime from './RealTime'

const RTMessages = () => {
  const queryClient = useQueryClient()
  const { conversationId } = useParams()

  const addMessage = message => {
    addMessageToConversation(queryClient, conversationId, message)
  }

  const updateMessage = message => {
    const queryKey = ['Conversation', `${conversationId}`]

    queryClient.setQueryData(queryKey, conversation => {
      if (!conversation?.messages) return conversation
      const { messages, ...others } = conversation
      const { records, ...pagesInfo } = messages
      return {
        ...others,
        messages: {
          ...pagesInfo,
          records: records.map(record =>
            record.id === message.id ? { ...record, ...message } : record
          ),
        },
      }
    })
  }

  const removeMessage = message => {
    const queryKey = ['Conversation', `${conversationId}`]

    queryClient.setQueryData(queryKey, conversation => {
      if (!conversation?.messages) return conversation
      const { messages, ...others } = conversation
      const { records, ...pagesInfo } = messages
      return {
        ...others,
        messages: {
          ...pagesInfo,
          records: records.filter(record => record.id !== message.id),
        },
      }
    })
  }

  const refetchConversation = () => {
    queryClient.invalidateQueries({
      queryKey: ['Conversation', `${conversationId}`],
    })
  }

  const handleEvent = ({ subject, data }) => {
    switch (subject) {
      case 'created':
        addMessage(data)
        break
      case 'status_updated':
        updateMessage(data)
        break
      case 'message_removed':
        removeMessage(data)
        break
      default:
        break
    }
  }

  return (
    <RealTime
      channel="Chat::ConversationMessagesChannel"
      conversationId={conversationId}
      onEvent={handleEvent}
      onReconnect={refetchConversation}
    />
  )
}

export default RTMessages
